import { BASEEFSchemas } from "../form/sharedSchemas/BASE/EF";
import { GHGEFSchemas } from "../form/sharedSchemas/GHG/EF";

export const getEFSchemaByStandard = (standardId) => {
  switch (standardId) {
    case 1:
      return BASEEFSchemas;
    case 2:
      return GHGEFSchemas;
    default:
      return BASEEFSchemas;
  }
};
